import {NgModule} from '@angular/core';

import {SavingTableDurationPipe, SavingTableAPYPipe, SavingTableBonusPipe, SavingAPYPipe, SavingDurationPipe, SavingComboDurationPipe} from './saving.pipe';

@NgModule({
  declarations: [SavingTableDurationPipe, SavingTableAPYPipe, SavingTableBonusPipe, SavingAPYPipe, SavingDurationPipe, SavingComboDurationPipe],
  exports: [SavingTableDurationPipe, SavingTableAPYPipe, SavingTableBonusPipe, SavingAPYPipe, SavingDurationPipe, SavingComboDurationPipe]
})
export class SavingPipesModule {}
